import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=1c4c6103&scoped=true&"
import script from "./svg.vue?vue&type=script&lang=js&"
export * from "./svg.vue?vue&type=script&lang=js&"
import style0 from "./svg.vue?vue&type=style&index=0&id=1c4c6103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c6103",
  null
  
)

export default component.exports